/*
  Fella Golf: "Notify me" popup op collectiepagina's.
  Een klik op het label opent een venster met maatkeuze en e-mailveld.
  Het verzoek gaat naar Klaviyo als Back in Stock aanmelding (per maat).
  Met het (standaard uitgeschakelde) vinkje wordt de klant ook aangemeld voor de Klaviyo Email List.
  Lukt Klaviyo niet, dan gaat het verzoek als terugval via het Shopify contactformulier naar de inbox.
  Zie ook snippets/market-stock.liquid voor het overzicht van aanpassingen.
*/
(function () {
  if (window.fgNotifyInit) return;
  window.fgNotifyInit = true;

  var KLAVIYO_PUBLIC_KEY = 'UbqDrU';
  var KLAVIYO_LIST_ID = 'V5vXbr'; // Email List
  var KLAVIYO_REVISION = '2024-10-15';

  var css = [
    '.fg-notify--overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9998;display:none;align-items:flex-end;justify-content:center}',
    '.fg-notify--overlay[data-open="true"]{display:flex}',
    '@media (min-width:768px){.fg-notify--overlay{align-items:center}}',
    '.fg-notify--dialog{background:#fff;color:#111;width:100%;max-width:420px;padding:24px 20px 28px;border-radius:16px 16px 0 0;box-sizing:border-box;position:relative;font-family:inherit}',
    '@media (min-width:768px){.fg-notify--dialog{border-radius:12px}}',
    '.fg-notify--close{position:absolute;top:10px;right:12px;background:none;border:0;font-size:26px;line-height:1;cursor:pointer;color:#111;padding:6px}',
    '.fg-notify--eyebrow{font-size:12px;letter-spacing:.08em;text-transform:uppercase;opacity:.7;margin:0 0 6px}',
    '.fg-notify--title{font-size:18px;margin:0 32px 16px 0;line-height:1.3}',
    '.fg-notify--label{display:block;font-size:13px;margin:0 0 6px}',
    '.fg-notify--field{width:100%;box-sizing:border-box;font:inherit;font-size:16px;padding:12px;border:1px solid #c9c9c9;border-radius:8px;margin:0 0 14px;background:#fff;color:#111}',
    '.fg-notify--submit{width:100%;font:inherit;font-size:14px;letter-spacing:.08em;text-transform:uppercase;padding:14px;border:0;border-radius:30px;background:#123d1f;color:#fff;cursor:pointer}',
    '.fg-notify--submit[disabled]{opacity:.6;cursor:default}',
    '.fg-notify--msg{font-size:14px;margin:12px 0 0;min-height:1em}',
    '.fg-notify--consent{display:flex;gap:10px;align-items:flex-start;font-size:13px;line-height:1.4;margin:0 0 16px;cursor:pointer}',
    '.fg-notify--consent input{width:18px;height:18px;margin:1px 0 0;flex:0 0 auto;accent-color:#123d1f}',
    '.fg-notify--msg[data-type="error"]{color:#b00020}',
    'button.product--label.fg-notify--trigger{border:0;font:inherit;letter-spacing:inherit;text-transform:inherit;cursor:pointer;line-height:inherit}'
  ].join('');

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var overlay, dialog, titleEl, sizeWrap, sizeSelect, emailInput, consentInput, submitBtn, msgEl, current, lastFocus;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'fg-notify--overlay';
    overlay.innerHTML =
      '<div class="fg-notify--dialog" role="dialog" aria-modal="true" aria-labelledby="fg-notify-title">' +
        '<button type="button" class="fg-notify--close" aria-label="Close">&times;</button>' +
        '<p class="fg-notify--eyebrow">Notify me when available</p>' +
        '<h2 class="fg-notify--title" id="fg-notify-title"></h2>' +
        '<form class="fg-notify--form" novalidate>' +
          '<div class="fg-notify--size-wrap">' +
            '<label class="fg-notify--label" for="fg-notify-size">Size</label>' +
            '<select class="fg-notify--field" id="fg-notify-size"></select>' +
          '</div>' +
          '<label class="fg-notify--label" for="fg-notify-email">Email</label>' +
          '<input class="fg-notify--field" id="fg-notify-email" type="email" autocomplete="email" inputmode="email" placeholder="Your email" required>' +
          '<label class="fg-notify--consent"><input type="checkbox" id="fg-notify-consent"><span>Also keep me updated on new drops and offers</span></label>' +
          '<button type="submit" class="fg-notify--submit">Notify me</button>' +
          '<p class="fg-notify--msg" aria-live="polite"></p>' +
        '</form>' +
      '</div>';
    document.body.appendChild(overlay);

    dialog = overlay.querySelector('.fg-notify--dialog');
    titleEl = overlay.querySelector('.fg-notify--title');
    sizeWrap = overlay.querySelector('.fg-notify--size-wrap');
    sizeSelect = overlay.querySelector('#fg-notify-size');
    emailInput = overlay.querySelector('#fg-notify-email');
    consentInput = overlay.querySelector('#fg-notify-consent');
    submitBtn = overlay.querySelector('.fg-notify--submit');
    msgEl = overlay.querySelector('.fg-notify--msg');

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    overlay.querySelector('.fg-notify--close').addEventListener('click', close);
    overlay.querySelector('form').addEventListener('submit', submit);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.getAttribute('data-open') === 'true') close();
    });
  }

  function setMsg(text, type) {
    msgEl.textContent = text || '';
    msgEl.setAttribute('data-type', type || '');
  }

  function open(trigger) {
    if (!overlay) build();
    lastFocus = trigger;
    var sizes = [];
    try { sizes = JSON.parse(trigger.getAttribute('data-sizes') || '[]'); } catch (e) { sizes = []; }
    current = { title: trigger.getAttribute('data-title') || '', variant: trigger.getAttribute('data-variant') || '' };

    titleEl.textContent = current.title;
    sizeSelect.innerHTML = '';
    if (sizes.length > 0) {
      sizes.forEach(function (s) {
        var o = document.createElement('option');
        o.value = s.id;
        o.textContent = s.t;
        sizeSelect.appendChild(o);
      });
      sizeWrap.style.display = '';
    } else {
      sizeWrap.style.display = 'none';
    }

    setMsg('');
    consentInput.checked = false;
    submitBtn.removeAttribute('disabled');
    submitBtn.textContent = 'Notify me';
    overlay.setAttribute('data-open', 'true');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { (sizes.length > 1 ? sizeSelect : emailInput).focus(); }, 50);
  }

  function close() {
    overlay.setAttribute('data-open', 'false');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  async function submit(e) {
    e.preventDefault();
    var email = emailInput.value.trim();
    if (!validEmail(email)) {
      setMsg('Please enter a valid email address', 'error');
      emailInput.focus();
      return;
    }
    var hasSizes = sizeWrap.style.display !== 'none';
    var variantId = hasSizes ? sizeSelect.value : current.variant;
    var sizeLabel = hasSizes ? sizeSelect.options[sizeSelect.selectedIndex].text : '';
    var wantsMarketing = consentInput.checked;

    submitBtn.setAttribute('disabled', 'true');
    submitBtn.textContent = 'Sending...';
    setMsg('');

    var ok = false;
    try {
      await klaviyoBackInStock(email, variantId);
      ok = true;
    } catch (err) {
      try {
        await contactFallback(email, current.title + (sizeLabel ? ' - ' + sizeLabel : ''));
        ok = true;
      } catch (err2) {
        ok = false;
      }
    }

    if (wantsMarketing) {
      try { await klaviyoSubscribe(email); } catch (err3) { /* aanmelding nieuwsbrief mislukt, BIS is wel gelukt */ }
    }

    if (ok) {
      emailInput.value = '';
      submitBtn.textContent = 'Done';
      setMsg("Thanks! We'll email you as soon as it's back in stock.", 'success');
      setTimeout(close, 2200);
    } else {
      submitBtn.removeAttribute('disabled');
      submitBtn.textContent = 'Notify me';
      setMsg('Something went wrong. Please try again.', 'error');
    }
  }

  function klaviyoPost(path, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo ' + res.status);
      return res;
    });
  }

  function klaviyoBackInStock(email, variantId) {
    if (!variantId) return Promise.reject(new Error('no variant'));
    return klaviyoPost('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
        }
      }
    });
  }

  function klaviyoSubscribe(email) {
    return klaviyoPost('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Notify me popup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
      }
    });
  }

  async function contactFallback(email, what) {
    var root = (window.theme && window.theme.urls && window.theme.urls.root) || '';
    var res = await fetch(root + '/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ form_type: 'contact', contact: { email: email, message: 'Please notify me when this is back in stock: ' + what } })
    });
    if (!res.ok) throw new Error(res.statusText);
    return res;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-fg-notify]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    open(trigger);
  }, true);
})();
